<script setup>
import { computed } from 'vue';
import { usePage, useForm } from '@inertiajs/vue3';
import ziggyRoute from '../ziggyRoute';

// 後端來的資料
const props = defineProps({
    ziggyConfig: Object,
});

// 登入表單
const page = usePage();
const form = useForm({
    account: null,
    password: null,
    remember: false,
});
const submitLoginForm = () => form.transform(data => ({
    _token: page.props.csrfToken,
    ...data,
})).post(ziggyRoute(props, 'login'));
</script>

<template>
<div class="flex-grow-1 d-flex justify-content-center align-items-center">
    <form class="form d-flex flex-column" @submit.prevent="submitLoginForm">
        <h3 class="form__title align-self-center">SIGN IN</h3>
        <div class="form__body d-flex flex-column">
            <input class="form__input" type="text" name="account" required placeholder="ID" v-model="form.account">
            <!-- `autocomplete="new-password"`: 避免瀏覽器自動填入帳密 -->
            <input
                class="form__input"
                type="password"
                name="password"
                required
                autocomplete="new-password"
                placeholder="Password"
                v-model="form.password">
            <div v-if="form.hasErrors" class="my-2">
                <div v-for="(message, _) in form.errors" class="text-danger my-1 text-center">{{ message }}</div>
            </div>
            <div class="d-flex align-items-center align-self-center">
                <div class="form__checkbox">
                    <input type="checkbox" id="stayed-sign-in" v-model="form.remember">
                    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="24" viewBox="0 0 33 24"><path fill="black" d="m0 10.909l4.364-4.364l8.727 8.727L28.364-.001l4.364 4.364l-19.636 19.636z"/></svg>
                </div>
                <label class="form__label ml-2" for="stayed-sign-in">Stayed Sign in</label>
            </div>
            <button class="form__button align-self-center" type="submit">Log in</button>
        </div>
        <div class="form__hint">Version：{{ page.props.appVersion }}</div>
    </form>
</div>
</template>
